"use client";

import { useMessages, useTranslations } from "next-intl";
import { CONTACTS } from "@/lib/site-contacts";

type MessageTree = Record<string, Record<string, string>>;

export default function Footer() {
  const t = useTranslations("Common");
  const messages = useMessages() as MessageTree;
  const commonMessages = messages.Common ?? {};
  const year = new Date().getFullYear();

  const translate = (key: string, fallback = key) => {
    if (typeof commonMessages[key] === "string") {
      return t(key as never);
    }

    return fallback;
  };

  const linkClass = "transition-colors hover:text-white";

  return (
    <footer className="bg-[#202e64] relative [transform:translateZ(0)]">
      <div className="mx-auto max-w-7xl px-4 py-10 text-xs text-white/70">
        <div className="text-white/90">{translate("brand")}</div>
        <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2">
          <a href={`mailto:${CONTACTS.email}`} className={linkClass}>
            {CONTACTS.email}
          </a>
          <a href={`tel:${CONTACTS.phone}`} className={linkClass}>
            {CONTACTS.phoneDisplay}
          </a>
          <a
            href={CONTACTS.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            WhatsApp
          </a>
          <a
            href={CONTACTS.telegramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {CONTACTS.telegramHandle}
          </a>
        </div>
        <p className="mt-3">© {year} · All rights reserved.</p>
      </div>
    </footer>
  );
}
